import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import {
  Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle, SheetClose,
} from "@/components/ui/sheet";

export const PUBLIC_LINKS = [
  { to: "/", label: "Home", testid: "public-nav-home" },
  { to: "/marketplace", label: "Marketplace", testid: "public-nav-marketplace" },
  { to: "/for-vendors", label: "For vendors", testid: "public-nav-for-vendors" },
  { to: "/einvoicing", label: "Matiqs Qonnect", testid: "public-nav-einvoicing" },
  { to: "/pricing", label: "Pricing", testid: "public-nav-pricing" },
  { to: "/how-it-works", label: "How it works", testid: "public-nav-how" },
  { to: "/faq", label: "FAQ", testid: "public-nav-faq" },
];

export function PublicMobileNav() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const appHome = user?.account_type === "contractor" ? "/marketplace" : user?.account_type === "einvoice" ? "/einvoicing/app" : "/dashboard";

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          data-testid="mobile-nav-toggle"
          aria-label="Open menu"
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-border text-foreground hover:bg-secondary transition-colors shrink-0"
        >
          <Menu className="w-5 h-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[82%] max-w-xs p-0">
        <SheetHeader className="px-5 pt-5 pb-3 border-b border-border text-left">
          <SheetTitle>
            <img src="/matiqs-logo.png" alt="Matiqs" className="brand-logo h-7 w-auto" />
          </SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col p-3" data-testid="mobile-nav-links">
          {PUBLIC_LINKS.map((l) => (
            <SheetClose asChild key={l.to}>
              <Link
                to={l.to}
                data-testid={`mobile-${l.testid}`}
                className={`px-3 py-3 rounded-lg text-base font-semibold transition-colors ${pathname === l.to ? "bg-secondary text-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary/60"}`}
              >
                {l.label}
              </Link>
            </SheetClose>
          ))}
        </nav>
        <div className="px-4 mt-2 flex flex-col gap-2">
          <Button
            data-testid="mobile-nav-signin"
            variant="outline"
            className="w-full h-11 font-semibold"
            onClick={() => { setOpen(false); navigate(user ? appHome : "/login"); }}
          >
            {user ? "My dashboard" : "Sign in"}
          </Button>
          {!user && (
            <Button
              data-testid="mobile-nav-getstarted"
              className="w-full h-11 font-semibold"
              onClick={() => { setOpen(false); navigate("/login?mode=register"); }}
            >
              Get started
            </Button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
